const development = {
  env: 'development',
  backendUrl: 'https://api-surveys.dev.antevenio.com',
}
export default development
